import SwipeListener from "swipe-listener";

const moreButtons = document.querySelectorAll(".open-nav");
const pageHeader = document.querySelector(".page-header");
const bodyTag = document.querySelector("body");
const hamburgerIcon = document.getElementById('hamburger-icon');

const toggleMenu = pageHeader?.querySelector(".toggle-menu");
const menuWrapper = pageHeader?.querySelector(".menu-wrapper");
const level1Links = pageHeader?.querySelectorAll(".level-1 > li > .nested");
const listWrapper2 = pageHeader?.querySelector(".list-wrapper:nth-child(2)");
const listWrapper3 = pageHeader?.querySelector(".list-wrapper:nth-child(3)");
const backOneLevelBtns = pageHeader?.querySelectorAll(".back-one-level");

const subMenuWrapper2 = listWrapper2?.querySelector(".sub-menu-wrapper");
const subMenuWrapper3 = listWrapper3?.querySelector(".sub-menu-wrapper");

const isVisibleClass = "is-visible";
const isActiveClass = "is-active";


// desktop nav: more button
if (moreButtons.length > 0) {
  moreButtons.forEach(button => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      menuWrapper?.classList.add(isVisibleClass);
      hamburgerIcon.classList.add('open');
    });
  });
}

// swipe gesture
const listener = SwipeListener(menuWrapper);
if (menuWrapper) {
  menuWrapper.addEventListener("swipe", (event) => {
	const directions = event.detail.directions;

	if (directions.right) {
      menuWrapper?.classList.toggle(isVisibleClass);
      hamburgerIcon.classList.toggle('open');
	}
  });
}


if (toggleMenu) {
  toggleMenu.addEventListener("click", function () {
	menuWrapper?.classList.toggle(isVisibleClass);
	hamburgerIcon.classList.toggle('open');
	bodyTag.classList.toggle('menu-open');
	if (!this.classList.contains(isVisibleClass)) {
      listWrapper2?.classList.remove(isVisibleClass);
      listWrapper3?.classList.remove(isVisibleClass);
	  if (menuWrapper) {
		const menuLinks = menuWrapper.querySelectorAll("a") || [];
		for (const menuLink of menuLinks) {
		  menuLink.classList.remove(isActiveClass);
		}
	  }
	}
  });
}


if (level1Links) {
  for (const level1Link of level1Links) {
    level1Link.addEventListener("click", function (event) {
      const siblingList = level1Link.nextElementSibling;
      if (siblingList) {
        event.preventDefault();
        this.classList.add(isActiveClass);
        const cloneSiblingList = siblingList.cloneNode(true);
        subMenuWrapper2.innerHTML = "";
        subMenuWrapper2.append(cloneSiblingList);
        listWrapper2.classList.add(isVisibleClass);
      }
      window.scrollTo({ top: 0, left: 0, behavior: "smooth"});
    });
  }
}


if (listWrapper2) {
  listWrapper2.addEventListener("click", function (event) {
    const target = event.target;
    if (target.tagName.toLowerCase() === "a" && target.nextElementSibling) {
      const siblingList = target.nextElementSibling;
      event.preventDefault();
      target.classList.add(isActiveClass);
      const cloneSiblingList = siblingList.cloneNode(true);
      subMenuWrapper3.innerHTML = "";
      subMenuWrapper3.append(cloneSiblingList);
      listWrapper3.classList.add(isVisibleClass);
    }
  });
}


if(backOneLevelBtns) {
  for (const backOneLevelBtn of backOneLevelBtns) {
    backOneLevelBtn.addEventListener("click", (event) => {
      const parent = event.target.closest(".list-wrapper");
	  if (parent !== null) {
		parent.classList.remove(isVisibleClass);
		for (const element of parent.previousElementSibling.getElementsByClassName(isActiveClass)) {
		  element.classList.remove(isActiveClass);
		}
	  }
    });
  }
}
